<template>
  <div class="flex items-center">
    <template v-if="!isEdit">
      <span v-if="label">{{ label }}</span>
      <span>{{ value }}</span>
      <el-button v-if="flag" class="!ml-4" type="text" size="default" @click="edit">
        <i class="el-icon-edit-outline text-info text-lg" />
      </el-button>

    </template>
    <template v-else>
      <el-input-number
        v-if="type=== 'number'"
        v-model="val"
        class="flex-1 min-w-0"
        size="medium"
        :controls="false"
      />
      <el-input v-else-if="type === 'string'" v-model="val" class="flex-1 min-w-0" placeholder="" size="medium" />
      <el-button class="!ml-4" type="text" size="default" @click="change">
        <i class="el-icon-check text-success text-lg" />
      </el-button>
      <el-button class="!ml-4" type="text" size="default" @click="cancel">
        <i class="el-icon-close text-muted text-lg" />
      </el-button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },

    value: {
      type: [String, Number],
      default: ''
    },
	flag: {
		type: Boolean,
		default: true
	},
    type: {
      type: String,
      default: 'number'
    }
  },

  data() {
    return {
      isEdit: false,
      val: ''
    }
  },

  methods: {
    edit() {
      this.isEdit = true
      this.val = this.value
    },

    change() {
      this.$emit('input', this.val)
      this.$emit('change', this.val)
      this.isEdit = false
    },

    cancel() {
      this.isEdit = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
